import { styled } from '@mui/material';

export const Page = styled('div')`
  height: 100vh;
  width: 100vw;
  overflow-y: auto;
`;
